import { DescriptionListItem as DsDescriptionListItem, type DescriptionListItemProps } from '@dhl-ui/components'
import type { WithOptional } from '~/common/type-util/WithOptional'

type Props = WithOptional<DescriptionListItemProps, 'description'> & {
  /**
   * used as a fallback if description is not provided and not loading, default is '-'
   */
  noInformationPlaceholder?: string
}

/**
 * same as DS, but with placeholder for description
 */
export const DescriptionListItem = ({ noInformationPlaceholder = '-', description, ...props }: Props) => (
  <DsDescriptionListItem {...props} description={description || noInformationPlaceholder} />
)
